import Vue from 'vue';
import { getTemplateLogic } from '@/design-system/logic';
import { mediaQueriesMixin, clickOutMixin } from '@/mixins';
import { Host } from '@/models/host';
import { categoryStore } from '@/store';
import { COT_SIDEBAR_AD_BANNER } from '@/constants';

export const adBannerLogic = Vue.extend({
    data() {
        return {
            categoryState: categoryStore.state,
        };
    },
    mixins: [mediaQueriesMixin, clickOutMixin],
    computed: {
        shouldDisplayAdbanner() {
            if (
                !this.categoryState.isLoaded ||
                !this.categoryState.bannerPartner
            ) {
                return false;
            }

            const host = Host.getInstance();

            if (this.isDesktop() && host.adBanner.isEnabledDesktop) {
                return true;
            }

            if (this.isMobileDevice() && host.adBanner.isEnabledMobile) {
                return true;
            }

            return false;
        },
        adBannerProps() {
            const bannerPartner = this.categoryState.bannerPartner;

            const clickOutUrl = this.goto(
                bannerPartner.cp_id,
                1,
                COT_SIDEBAR_AD_BANNER
            );

            const ctaText = getTemplateLogic().ctaButtonText({
                partner: bannerPartner,
                host: this.$globalConstants.host,
            });

            const description =
                bannerPartner.members ||
                bannerPartner.marketing_properties.discount_button;

            const logoSize = this.isMobile() ? '65' : '105';
            const bannerImgSource =
                this.$globalConstants.host['partner_sidebar_banner_image'];
            return {
                ...this.$globalConstants.components.AdBanner,
                bannerPartner,
                clickOutUrl,
                ctaText,
                description,
                logoSize,
                bannerImgSource,
            };
        },
    },
});
